module.exports = {
frame:{
    right_position: {
        y: 4,
        x: 164
    },
    bottom_position: {
        y: 164,
        x: 0
    },
    left_position: {
        y: 4,
        x: 0
    },
    top_position: {
        y: 0,
        x: 0
    }
}
};



//////////////////
// WEBPACK FOOTER
// ./cfg/frames-config.js
// module id = 18
// module chunks = 0